import styled from "styled-components";
import { SVGPlusAccordion, SVGMinusAccordion } from "@/lib/svg";
import { H4 } from "@/lib/styles";

export const Title = styled(H4)`
  display: block;
  color: ${({ theme }) => theme.colors.darkMiddle};
  font-family: ${({ theme }) => theme.fontFamilies.primary};
  background-color: ${({theme})=> theme.colors.white};
  transition: color 0.1s ease-in;
`;

export const ItemContainer = styled.div`
  width: 100%;
  position: relative;

  transition: all 0.1s ease-in;
  &:hover {
    ${Title} {
      color: ${({ theme }) => theme.colors.black};
    }
  }
`;
export const Heading = styled.div`
  display: grid;
  grid-template-columns: 32px auto;
  grid-template-rows: 1fr;
  gap: 24px;
  &:hover {
    cursor: pointer;
  }
`;

// Title above

export const IconWrapper = styled.div`
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  &:hover {
    cursor: pointer;
  }
`;
export const IconPlus = styled(SVGPlusAccordion)`
  width: 32px;
  height: 32px;
`;
export const IconMinus = styled(SVGMinusAccordion)`
  width: 32px;
  height: 2px;
`;

export const ContentAccordion = styled.div``;

export const Article = styled.article`
  position: relative;
  margin-left: auto;
  padding: 2.5rem 0;
  background: ${({ theme }) => theme.colors.white};

  ${({ theme }) => theme.mediaQueries.laptop} {
    padding: 2.5rem 1.5rem;
  }
`